import { render } from "./ChangePassword.vue?vue&type=template&id=b7bc183a&scoped=true&ts=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=b7bc183a&scoped=true&lang=css"

import exportComponent from "/workspace/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7bc183a"]])

export default __exports__